import { render, staticRenderFns } from "./createMenuModel.vue?vue&type=template&id=e300fbe0&scoped=true"
import script from "./createMenuModel.vue?vue&type=script&lang=js"
export * from "./createMenuModel.vue?vue&type=script&lang=js"
import style0 from "./createMenuModel.vue?vue&type=style&index=0&id=e300fbe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e300fbe0",
  null
  
)

export default component.exports